import { marketingTrackingEmitterEvent } from '../../../common/emitters/marketingTrackingEmitter';
import { TrackingService } from '../../../common/tracking/trackingService';

type LoginSource = 'google' | 'linkedin' | 'email';
export const trackEmployerLoggedInEvent = (source: LoginSource) => {
  TrackingService.logEvent('Employer Logged In', {
    source,
  });
  marketingTrackingEmitterEvent.emit({
    event: 'employer_logged_in',
    payload: {
      source,
    },
  });
};
